import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { experimentsSlice } from 'hooks/use-experiment'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'

import confirmOrganizerPasswordSlice from './slices/confirm-organizer-password-slice'
import confirmPasswordSlice from './slices/confirm-password-slice'
import dataSlice from './slices/data-slice'
import iamSlice from './slices/iam-slice'
import oneTimeEmailOtpSlice from './slices/one-time-email-otp-slice'
import sessionSlice from './slices/session-slice'
import smsAcsBlockedSlice from './slices/sms-acs-blocked-slice'
import toastSlice from './slices/toast-slice'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['session', 'iam', 'data']
}

const rootReducer = combineReducers({
  session: sessionSlice.reducer,
  toast: toastSlice.reducer,
  data: dataSlice.reducer,
  iam: iamSlice.reducer,
  experiments: experimentsSlice.reducer,
  confirmPassword: confirmPasswordSlice.reducer,
  confirmOrganizerPassword: confirmOrganizerPasswordSlice.reducer,
  oneTimeEmailOtp: oneTimeEmailOtpSlice.reducer,
  smsAcsBlocked: smsAcsBlockedSlice.reducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const initialState = {}

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: initialState,
  enhancers: (defaultEnhancers) => [...defaultEnhancers]
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = () => useDispatch<AppDispatch>()

export * from './slices'
